export enum PolicyStatus {
    CONFIRMED = 'CONFIRMED',
    CANCELLED = 'CANCELLED'
}

export enum AimsStatus {
    UNDEBITED = 'UNDEBITED',
    DEBITED = 'DEBITED'
}

export enum PolicyFlag{
    ALL = 'ALL',
    SELF = 'SELF'
}
